/**
 * Block-element lookups shared by anything that turns a sub-cell bitmap into
 * characters: image conversion, the text generator, and the Braille tools.
 */

/** Quadrant bit pattern (top-left, top-right, bottom-left, bottom-right). */
export const QUADRANT_CHARS: Record<string, string> = {
  '0000': ' ',
  '1000': '▘',
  '0100': '▝',
  '1100': '▀',
  '0010': '▖',
  '1010': '▌',
  '0110': '▞',
  '1110': '▛',
  '0001': '▗',
  '1001': '▚',
  '0101': '▐',
  '1101': '▜',
  '0011': '▄',
  '1011': '▙',
  '0111': '▟',
  '1111': '█',
};

export function quadrantChar(tl: boolean, tr: boolean, bl: boolean, br: boolean): string {
  return QUADRANT_CHARS[`${+tl}${+tr}${+bl}${+br}`] ?? ' ';
}

/** Upper/lower half pair: the two-pixels-per-cell workhorse. */
export function halfBlockChar(top: boolean, bottom: boolean): string {
  if (top && bottom) return '█';
  if (top) return '▀';
  if (bottom) return '▄';
  return ' ';
}

/** The shading ramp, lightest to darkest. */
export const SHADE_RAMP = ['░', '▒', '▓', '█'] as const;

/** Picks a shade for a coverage value in 0..1. */
export function shadeFor(coverage: number): string {
  if (coverage <= 0) return ' ';
  const i = Math.min(SHADE_RAMP.length - 1, Math.floor(coverage * SHADE_RAMP.length));
  return SHADE_RAMP[i];
}
